export var ReservationType;
(function (ReservationType) {
    ReservationType["MANUAL"] = "manual";
    ReservationType["WIDGET"] = "widget";
})(ReservationType || (ReservationType = {}));
export var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus["APPROVAL_PENDING"] = "approval_pending";
    ReservationStatus["APPROVED"] = "approved";
    ReservationStatus["DECLINED"] = "declined";
    ReservationStatus["FULFILLED"] = "fulfilled";
    ReservationStatus["NO_SHOW"] = "no_show";
    ReservationStatus["GUEST_CANCELLED"] = "guest_cancelled";
    ReservationStatus["RESTAURANT_CANCELLED"] = "restaurant_cancelled";
    // No-Show Protection: the table is held until the guest leaves the payment guarantee
    ReservationStatus["GUARANTEE_PENDING"] = "guarantee_pending";
    // the guarantee wasn't left in time (or the restaurant released the table)
    ReservationStatus["GUARANTEE_EXPIRED"] = "guarantee_expired";
})(ReservationStatus || (ReservationStatus = {}));
